import ReactPlayer from 'react-player'

import { Video as VideoSchema } from 'src/config/generated/sanitySchema'

interface VideoPlayerProps extends VideoSchema {
  playing?: boolean
}

const VideoPlayer = ({ source, playing = false }: VideoPlayerProps) => {
  return (
    <div className='w-full aspect-video'>
      <ReactPlayer
        src={source}
        controls
        width='100%'
        height='100%'
        playing={playing}
      />
    </div>
  )
}

export default VideoPlayer
